import { LinkedCentralSystem as ApiLinkedCentralSystem } from '@infuse/api/e-connector/central-system';
import { enumFromStringValue } from '@infuse/utils';
import { LinkedCentralSystem, LinkedCentralSystemType } from '@infuse/e-connector/central-system/domain';

/**
 * Common function to map a LinkedCentralSystem from the domain model to the API model.
 *
 * @param linkedCentralSystem
 */
export const mapLinkedCentralSystemToApi = (linkedCentralSystem: LinkedCentralSystem): ApiLinkedCentralSystem => {
  return {
    chargePoint: linkedCentralSystem.chargingStationId,
    centralSystem: linkedCentralSystem.centralSystemId,
    type: linkedCentralSystem.type,
    customChargePointName: linkedCentralSystem.customChargingStationName,
    commandsAllowed: linkedCentralSystem.commandsAllowed,
    sessionAuthorizationAllowed: linkedCentralSystem.sessionAuthorizationAllowed,
    forwardBasicAuth: linkedCentralSystem.forwardBasicAuth,
    createdAt: linkedCentralSystem.createdAt,
    updatedAt: linkedCentralSystem.updatedAt
  };
};

/**
 * Common function to map a LinkedCentralSystem from the API model to the domain model.
 *
 * @param apiLinkedCentralSystem
 */
export const mapLinkedCentralSystemToDomain = (apiLinkedCentralSystem: ApiLinkedCentralSystem): LinkedCentralSystem => {
  return {
    centralSystemId: apiLinkedCentralSystem.centralSystem,
    chargingStationId: apiLinkedCentralSystem.chargePoint,
    type: enumFromStringValue(LinkedCentralSystemType, apiLinkedCentralSystem.type),
    customChargingStationName: apiLinkedCentralSystem.customChargePointName,
    commandsAllowed: apiLinkedCentralSystem.commandsAllowed,
    sessionAuthorizationAllowed: apiLinkedCentralSystem.sessionAuthorizationAllowed,
    forwardBasicAuth: apiLinkedCentralSystem.forwardBasicAuth,
    createdAt: new Date(apiLinkedCentralSystem.createdAt),
    updatedAt: new Date(apiLinkedCentralSystem.updatedAt)
  };
};
